import React from "react";
import { useRememberPasswordAPIMutation } from "../../redux/services/auth/registerAPI";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import queryString from 'query-string';
import Swal from 'sweetalert2';

export default function CheckMobile() {
  const [RememberPasswordAPI] = useRememberPasswordAPIMutation();
  const navigate = useNavigate();

  const form = useFormik({
    initialValues: { mobile_number: "" },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const response = await RememberPasswordAPI(queryString.stringify({
        mobile_number: values.mobile_number,
      }));

      if (response.data) {
        Swal.fire({ icon: 'success', text: `Active code is sent to your email`, timer: 1600, showConfirmButton: false, customClass: { popup: 'sweetalert2-custom-popup' } });
        navigate('/verify', { state: { check_mobile: true, user_id: response.data.user.id } });
      } else {
        Swal.fire({ icon: 'warning', text: response.error?.data?.non_field_errors?.[0] || response.error?.data?.message || 'Unable to send code.', confirmButtonText: 'OK', customClass: { popup: 'sweetalert2-custom-popup' } });
      }

      resetForm();
      setTimeout(() => setSubmitting(false), 300);
    },
    validate: (values) => {
      const errors = {};
      if (!values.mobile_number) errors.mobile_number = 'Mobile number is required';
      return errors;
    }
  });

  const fieldClass = (name) => `field ${form.errors[name] && form.touched[name] ? 'border-red-300 ring-4 ring-red-50' : ''}`;

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell max-w-3xl">
        <div className="premium-card bg-white p-6 sm:p-8">
          <span className="eyebrow">Password recovery</span>
          <h1 className="section-title mt-5">Find your account</h1>
          <p className="section-copy">Enter your mobile number and we will send recovery instructions to your email.</p>

          <form onSubmit={form.handleSubmit} className="mt-8">
            <label><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Mobile number</span><input className={fieldClass('mobile_number')} name="mobile_number" value={form.values.mobile_number} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            {form.errors.mobile_number && form.touched.mobile_number && <p className="mt-2 text-sm font-bold text-red-500">{form.errors.mobile_number}</p>}

            <button type="submit" disabled={form.isSubmitting} className="btn-primary mt-6 w-full">{form.isSubmitting ? 'Loading...' : 'Send recovery code'}</button>
          </form>
        </div>
      </div>
    </section>
  );
}
